import React from 'react'
import '../../styles/GetAShareStyles/factory.css'

import {connect} from 'react-redux'

import FactoryImg from './../../resources/GetAShareResources/factory.svg'
import Meter from './../../resources/GetAShareResources/meter.svg'
import MeterBar from './../../resources/GetAShareResources/meter-bar.svg'

import TopLine from './../../resources/GetAShareResources/top-line.svg'
import Circle from './../../resources/GetAShareResources/circle.svg'

import Pivot from './../../resources/GetAShareResources/pivot.svg'
import LeftHand from './../../resources/GetAShareResources/left-hand.svg'
import RightHand from './../../resources/GetAShareResources/right-hand.svg'
import Card from './../../resources/GetAShareResources/card.svg'

import Conveyer from './../../resources/GetAShareResources/conveyer.svg'
import ConveyerWheel from './../../resources/GetAShareResources/conveyer-wheel.svg'

import FactoryHeart from './../../resources/GetAShareResources/factory-heart.svg'

import FactoryWallet from './../../resources/GetAShareResources/wallet.svg'
import KronnCoin from './../../resources/GetAShareResources/kronn-coin.svg'


class Factory extends React.Component{
    render(){
        return(
            <div className="fac__container">
                <img  className="fac__img" src={FactoryImg} />

                <div className="fac__screen">
                    <div className="fac__screen-1">
                        <div className="fac__screen-dot-1"></div>
                        <div className="fac__screen-line-1"></div>
                    </div>

                    <div className="fac__screen-2">
                        <div className="fac__screen-dot-1"></div>
                        <div className="fac__screen-line-1"></div>
                    </div>

                    <div className="fac__screen-2">
                        <div className="fac__screen-dot-2"></div>
                        <div className="fac__screen-line-1"></div>
                    </div>
                    <div className="fac__screen-2">
                        <div className="fac__screen-dot-3"></div>
                        <div className="fac__screen-line-1"></div>
                    </div>

                    <div className="fac__screen-3">
                        <div className="fac__screen-dot-1"></div>
                        <div className="fac__screen-line-1"></div>
                    </div>
                </div>

                <div className="fac__conveyer">
                    <img src={Conveyer} />

                    <div className="fac__white-space" />

                    <div className="fac__wheel">
                        <img src={ConveyerWheel} className="fac__wheel-spin"/>
                        <img src={ConveyerWheel} className="fac__wheel-spin"/>
                        <img src={ConveyerWheel} className="fac__wheel-spin"/>
                        <img src={ConveyerWheel} className="fac__wheel-spin"/>
                    </div>

                    <img className="fac__wallet" src={FactoryWallet} />

                    <img className="fac__coin" src={KronnCoin} />

                </div>

                <div className="fac__meter-1">
                    <img className="fac__meter-1-img" src={Meter} />
                    <img className="fac__meter-1-bar" src={MeterBar} />
                </div>

                <div className="fac__meter-2">
                    <img className="fac__meter-2-img" src={Meter} />
                    <img className="fac__meter-2-bar" src={MeterBar} />
                </div>

                <div className="fac__heart">
                    {/* <img src={FactoryHeart} /> */}
                </div>

                <div className="fac__bottom-screen-container">

                    <div className="fbsc__">
                        <div className="fbsc__1-1"/>
                        <div className="fbsc__1-2"/>
                        <div className="fbsc__1-3"/>
                        <div className="fbsc__1-4"/>
                    </div>

                    <div className="fbsc__">
                        <div className="fbsc__2-1"/>
                        <div className="fbsc__2-2"/>
                        <div className="fbsc__2-3"/>
                        <div className="fbsc__2-4"/>
                    </div>
                    <div className="fbsc__">
                        <div className="fbsc__3-1"/>
                        <div className="fbsc__3-2"/>
                        <div className="fbsc__3-3"/>
                        <div className="fbsc__3-4"/>
                    </div>
                    <div className="fbsc__">
                        <div className="fbsc__4-1"/>
                        <div className="fbsc__4-2"/>
                        <div className="fbsc__4-3"/>
                        <div className="fbsc__4-4"/>
                    </div>
                    <div style={{height: '2px'}}></div>
                    <div className="fbsc__">
                        <div className="fbsc__5-1"/>
                        <div className="fbsc__5-2"/>
                        <div className="fbsc__5-3"/>
                        <div className="fbsc__5-4"/>
                    </div>
                </div>

                <div className="fac__top-line">
                    <img src={TopLine} />
                    <div className="fac__top-circles">
                        <img src={Circle} className="fac__top-circle"/>
                        <img src={Circle} className="fac__top-circle"/>
                        <img src={Circle} className="fac__top-circle"/>
                        <img src={Circle} className="fac__top-circle"/>
                        <img src={Circle} className="fac__top-circle"/>
                    </div>
                    <div className="fac__top-movable">
                        <div className="fac__top-pivot-hand">
                            <img className="fac__pivot" src={Pivot}/>
                            <img className="fac__left-hand" src={LeftHand}/>
                            <img className="fac__right-hand" src={RightHand}/>
                            <img className="fac__card" src={Card}/>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

const mapStatesToProps = (state) =>{
    return{
        windowDimensions: state.windowDimensions,
    }
}


export default connect(mapStatesToProps)(Factory)



// WEBPACK FOOTER //
// ./src/components/GetAShare/Factory.js